import HttpService from '~/zf/frontend/common/http/HttpService';
import Endpoint from '../const/endpoint';
import MappingService from './MappingService';
async function loadComponentTree(componentId, componentType, systemId, shouldCascade) {
    const { data } = await HttpService.get(Endpoint.LOAD_COMPONENT_TREE, {
        params: {
            componentId, componentType, shouldCascade, systemId,
        },
    });
    return MappingService.mapMutedComponentToComponentTree(data);
}
const ApiService = {
    loadComponentTree,
};
export default ApiService;
